module.exports = __webpack_public_path__ + "static/media/patrol(26).b1ef4adf.PNG";